export default {
      id: "notification-bell-usage",
      viewBox: "0 0 30.175 35.644",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#notification-bell",
      toString: function () {
        return this.url;
      }
    }